<div class="authPage">
  <div class="authFormPane">
    <a class="authLogo" routerLink="/login">
      <div class="logoBox"><img src="assets/img/icons/envision-menu-72px.png" alt="Urbanhub"></div>
      <span class="logoText"><b>Urban</b>hub</span>
    </a>

    <div class="authFormContent">
      @if (challenge) {
        <div>
          <button type="button" class="uvLinkButton authLink authReturn" (click)="backToPassword()">
            {{ 'GENERAL.RETURN_LOGIN' | translate }}
          </button>
          <h1 class="authTitle">{{ 'LOGIN.CODE_TITLE' | translate }}</h1>
          <p class="authSubtitle">
            @if (useRecovery) {
              {{ 'LOGIN.RECOVERY_HINT' | translate }}
            } @else if (challenge.method === 'totp') {
              {{ 'LOGIN.CODE_APP_HINT' | translate }}
            } @else {
              {{ 'LOGIN.CODE_EMAIL_HINT' | translate: { email: challenge.emailHint, minutes: challenge.validMinutes } }}
            }
          </p>
        </div>

        <form class="authForm" [formGroup]="codeForm" (ngSubmit)="submitCode()">
          <div class="authField">
            <label for="loginCode">{{ (useRecovery ? 'LOGIN.RECOVERY_LABEL' : 'LOGIN.CODE_LABEL') | translate }}</label>
            <mat-form-field appearance="outline" class="customMatFormField">
              @if (useRecovery) {
                <input #codeInput id="loginCode" type="text" matInput formControlName="code"
                  autocomplete="off" autocapitalize="none" spellcheck="false" (input)="codeError = null">
              } @else {
                <input #codeInput id="loginCode" type="text" matInput formControlName="code"
                  inputmode="numeric" autocomplete="one-time-code" (input)="normalizeCode()">
              }
            </mat-form-field>
          </div>

          @if (!isNative && !useRecovery) {
            <mat-checkbox class="authCheckbox uvCheckboxFlush" formControlName="trust">{{ 'LOGIN.REMEMBER_BROWSER' | translate }}</mat-checkbox>
          }

          @if (lockSeconds > 0) {
            <mat-error>
              {{ 'LOGIN.TOO_MANY_ATTEMPTS' | translate: { time: lockLabel } }}
            </mat-error>
          } @else if (codeError) {
            <mat-error>
              {{ codeError | translate: { left: challenge.attemptsLeft } }}
            </mat-error>
          } @else if (challenge.resent) {
            <p class="authHint">{{ 'LOGIN.RESEND_DONE' | translate }}</p>
          }

          <div class="authActions">
            @if (challenge.method === 'totp') {
              <button type="button" class="uvLinkButton authLink" (click)="toggleRecovery()">
                {{ (useRecovery ? 'LOGIN.USE_CODE' : 'LOGIN.USE_RECOVERY') | translate }}
              </button>
            } @else if (challenge.resendAt !== null && resendSeconds > 0) {
              <span class="authHint">{{ 'LOGIN.RESEND_WAIT' | translate: { time: resendLabel } }}</span>
            } @else if (challenge.resendAt !== null) {
              <button type="button" class="uvLinkButton authLink" (click)="resend()">{{ 'LOGIN.RESEND' | translate }}</button>
            }
          </div>

          <button type="submit" mat-flat-button class="actionButton authSubmit" [disabled]="lockSeconds > 0">
            {{ 'LOGIN.LOGIN' | translate }}
          </button>
        </form>
      } @else {
        <div>
          <h1 class="authTitle">{{ 'LOGIN.TITLE' | translate }}</h1>
          <p class="authSubtitle">{{ 'LOGIN.WELCOME' | translate }}</p>
        </div>

        <form class="authForm" [formGroup]="form" (ngSubmit)="submit()">
          <div class="authField">
            <label for="loginUsername">{{ 'LOGIN.USERNAME' | translate }}</label>
            <mat-form-field appearance="outline" class="customMatFormField">
              <input id="loginUsername" type="text" matInput formControlName="username"
                (keydown)="error = null" autocomplete="username">
            </mat-form-field>
          </div>

          <div class="authField">
            <label for="loginPassword">{{ 'LOGIN.PASSWORD' | translate }}</label>
            <mat-form-field appearance="outline" class="customMatFormField">
              <input id="loginPassword" [type]="hide ? 'password' : 'text'" matInput formControlName="password"
                (keydown)="error = null" autocomplete="current-password">
              <!-- Material projects the suffix statically: through a template outlet it
                   would stay inline in the field instead of moving to the right edge. -->
              <div matSuffix [innerHTML]="icons[hide ? 'visibility-off-outline' : 'visibility-outline']"
                class="pointer authFieldIcon" [class.hideIcon]="hide" [class.showIcon]="!hide"
                (click)="hide = !hide"></div>
            </mat-form-field>
          </div>

          @if (lockSeconds > 0) {
            <mat-error>
              {{ 'LOGIN.TOO_MANY_ATTEMPTS' | translate: { time: lockLabel } }}
            </mat-error>
          } @else if (error) {
            <mat-error>
              {{ error }}
            </mat-error>
          }

          <div class="authActions">
            <a class="authLink" routerLink="../forgot-password">{{ 'LOGIN.FORGOT' | translate }}</a>
          </div>

          <button type="submit" mat-flat-button class="actionButton authSubmit" [disabled]="lockSeconds > 0">
            {{ 'LOGIN.LOGIN' | translate }}
          </button>
        </form>
      }
    </div>
  </div>

  <div class="authVisualPane">
    <img class="authCityImg" src="assets/img/auth/city-square.png" alt="">

    <div class="authSlider" [class.dragging]="isDragging"
      (pointerdown)="onDragStart($event)" (pointermove)="onDragMove($event)"
      (pointerup)="onDragEnd()" (pointerleave)="onDragEnd()" (pointercancel)="onDragEnd()">
      <div class="sliderTrack" [style.transform]="sliderTransform">
        @for (slide of slides; track $index) {
          <div class="sliderCard">
            <img [src]="slide" alt="" draggable="false">
          </div>
        }
      </div>
      <div class="sliderDots">
        @for (slide of slides; track $index) {
          <button type="button" [class.active]="$index === currentSlide" (click)="goToSlide($index)"
            [attr.aria-label]="'slide ' + ($index + 1)"></button>
        }
      </div>
    </div>

    <div class="authCaption">
      <h2>{{ 'LOGIN.EXTRA_TITLE' | translate }}</h2>
      <p>{{ 'LOGIN.EXTRA_SUBTITLE' | translate }}</p>
    </div>
  </div>
</div>
